import React from 'react';

import LoginPageContent from '../components/loginPageContent';

const Login = () => {
  return <LoginPageContent />;
};

export default Login;
